import React from 'react';

const DEMO_LADDER = ['Аналитик', 'Менеджер', 'Директор', 'Партнёр'];

const DEMO_COMPONENTS = [
  { label: 'FIX', status: 'в рынке', fill: 52 },
  { label: 'STI', status: 'в рынке', fill: 48 },
  { label: 'LTIP', status: 'ниже рынка', fill: 28 },
  { label: 'Total Comp', status: 'в рынке', fill: 55 },
];

function statusClass(status: string): string {
  if (status === 'ниже рынка') return 'below';
  if (status === 'выше рынка') return 'above';
  return 'in';
}

/** Демонстрационный дэшборд рыночных данных без реальных значений */
export default function MarketDataDemoDashboard() {
  return (
    <div className="dcf-mp-demo-dash" aria-hidden="true">
      <div className="dcf-mp-demo-dash__head">
        <span className="dcf-mp-demo-dash__label">
          <i className="fas fa-eye" aria-hidden="true" />
          Пример того, что откроется после заполнения
        </span>
        <span className="dcf-mp-lock-note">
          <i className="fas fa-lock" aria-hidden="true" />
          Демо-данные
        </span>
      </div>

      <div className="dcf-mp-md-layout dcf-mp-demo-dash__layout">
        <section className="dcf-mp-card dcf-mp-md-panel dcf-mp-md-panel--wide dcf-mp-demo-dash__panel">
          <h2 className="dcf-mp-card__title">Компенсация относительно рынка</h2>
          <p className="dcf-mp-form-hint">Сравнение по роли, уровню и выбранной группе рынка.</p>

          <div className="dcf-mp-result-status dcf-mp-md-status">
            <span className="dcf-mp-market-badge dcf-mp-market-badge--in">в рынке</span>
            <p className="dcf-mp-md-status__headline dcf-mp-demo-dash__masked-text">
              Компенсация близка к медиане группы
            </p>
          </div>

          <div className="dcf-mp-quartile dcf-mp-demo-dash__quartile">
            <div className="dcf-mp-quartile__track">
              {[
                { pos: 25, label: 'P25' },
                { pos: 50, label: 'P50' },
                { pos: 75, label: 'P75' },
                { pos: 90, label: 'P90' },
              ].map((m) => (
                <div key={m.label} className="dcf-mp-quartile__tick" style={{ left: `${m.pos}%` }}>
                  <span className="dcf-mp-quartile__tick-line" />
                  <span className="dcf-mp-quartile__tick-label">{m.label}</span>
                </div>
              ))}
            </div>
            <div className="dcf-mp-quartile__legend">
              <span>нижний квартиль</span>
              <span>медиана</span>
              <span>верхний квартиль</span>
              <span>высокий диапазон</span>
            </div>
          </div>

          <p className="dcf-mp-percentile__value dcf-mp-demo-dash__masked-text">
            Ваш перцентиль: ~··
          </p>

          <div className="dcf-mp-md-comp-rows">
            {DEMO_COMPONENTS.map((row) => (
              <div key={row.label} className="dcf-mp-comp-row dcf-mp-demo-dash__comp-row">
                <div className="dcf-mp-comp-row__head">
                  <span className="dcf-mp-comp-row__name">{row.label}</span>
                  <span className={`dcf-mp-comp-row__badge dcf-mp-comp-row__badge--${statusClass(row.status)}`}>
                    {row.status}
                  </span>
                </div>
                <div className="dcf-mp-comp-row__value dcf-mp-demo-dash__masked-value">••• ••• ₽</div>
                <div className="dcf-mp-comp-row__bar">
                  <div
                    className="dcf-mp-comp-row__fill dcf-mp-demo-dash__bar-fill"
                    style={{ width: `${row.fill}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </section>

        <div className="dcf-mp-md-side">
          <section className="dcf-mp-card dcf-mp-md-panel dcf-mp-demo-dash__panel">
            <h2 className="dcf-mp-card__title">С кем вы сравниваетесь</h2>
            <dl className="dcf-mp-comp-list">
              <div><dt>Режим</dt><dd className="dcf-mp-demo-dash__masked-text">Мой сектор</dd></div>
              <div><dt>Индустрия</dt><dd className="dcf-mp-demo-dash__masked-text">••• •••</dd></div>
              <div><dt>Сектор</dt><dd className="dcf-mp-demo-dash__masked-text">••• •••</dd></div>
              <div><dt>Роль</dt><dd className="dcf-mp-demo-dash__masked-text">••• •••</dd></div>
              <div><dt>Уровень по грейдингу</dt><dd className="dcf-mp-demo-dash__masked-text">G·</dd></div>
              <div><dt>Релевантных профилей</dt><dd className="dcf-mp-demo-dash__masked-text">~··</dd></div>
            </dl>
          </section>

          <section className="dcf-mp-card dcf-mp-md-panel dcf-mp-demo-dash__panel">
            <h2 className="dcf-mp-card__title">Положение в грейдинговом дереве</h2>
            <nav className="dcf-mp-hierarchy dcf-mp-demo-dash__hierarchy">
              <span className="dcf-mp-demo-dash__masked-text">Индустрия</span>
              <i className="fas fa-chevron-right" aria-hidden="true" />
              <span className="dcf-mp-demo-dash__masked-text">Сектор</span>
              <i className="fas fa-chevron-right" aria-hidden="true" />
              <span className="dcf-mp-demo-dash__masked-text">Кластер роли</span>
            </nav>
            <ol className="dcf-mp-grade-ladder dcf-mp-demo-dash__ladder">
              {DEMO_LADDER.map((role) => (
                <li key={role} className="dcf-mp-grade-ladder__item">
                  <span className="dcf-mp-grade-ladder__name">{role}</span>
                </li>
              ))}
            </ol>
            <p className="dcf-mp-card__footnote">
              Ваш уровень и рыночный эквивалент появятся после грейдинга.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
